import { TextBoxCheckIcon } from './TextBoxCheckIcon';

/**
 * author: mocking-mike
 * id 291424C4-8874-4D0D-8D89-0C3349C021ED
 * name text-box-check
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text-box-check.svg
 * tags
 * - Files / Folders 
 */
export const FileDocumentBoxCheckIcon = TextBoxCheckIcon;
export default FileDocumentBoxCheckIcon